import styled from "@emotion/styled";
import { Stack } from "@mui/material";

export const StackStyled = styled(Stack)`
  width: 100%;
`;
